<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 24 24"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M3.6129 6.2097L3.70711 6.29289L10 12.585L13.2929 9.29289C13.6534 8.93241 14.2206 8.90468 14.6129 9.2097L14.7071 9.29289L19 13.585L20.2929 12.2929C20.8955 11.6903 21.9072 12.0723 21.994 12.8864L22 13L21.9983 17.0594L21.9893 17.1469L21.9643 17.2658L21.9401 17.3417L21.9063 17.4232L21.854 17.5207L21.7871 17.617L21.7071 17.7071C21.6717 17.7425 21.6343 17.7747 21.5953 17.8037L21.4841 17.8753L21.3713 17.9288L21.266 17.9642L21.1485 17.989L21.0893 17.996L21 18H17C16.1478 18 15.7026 17.0145 16.2168 16.3775L16.2929 16.2929L17.585 15L14 11.415L10.7071 14.7071C10.3466 15.0676 9.77939 15.0953 9.3871 14.7903L9.29289 14.7071L2.29289 7.70711C1.90237 7.31658 1.90237 6.68342 2.29289 6.29289C2.65338 5.93241 3.22061 5.90468 3.6129 6.2097Z"
    fill="currentColor"
  />
</svg>
